import { render } from "./MembershipEdit.vue?vue&type=template&id=6ba87008"
import script from "./MembershipEdit.vue?vue&type=script&lang=js"
export * from "./MembershipEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__